const KakaoSDK = {
  install(Vue) {
    const { Kakao } = window;

    if (!Kakao || (Kakao && !Kakao.isInitialized())) {
      Kakao.init(process.env.VUE_APP_KAKAO_SDK_JS_KEY);
    }

    Vue.prototype.$KakaoSDK = Kakao;
  }
};

export default KakaoSDK;
